define('pwa/plugin/tickets/view/TicketsItemView',['require','lib/view/LayoutView','lib/view/ModalRegion','pwa/plugin/tickets/view/TicketsItemDialogView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ModalRegion = require('lib/view/ModalRegion');
    var TicketsItemDialogView = require('pwa/plugin/tickets/view/TicketsItemDialogView');

    /**
     * Tickets item view
     *
     * @class TicketsItemView
     */
    return LayoutView.extend({

        template: '#tickets_item_view',
        ui: {
            showTicket: '.sb_show_ticket'
        },
        events: {
            'click @ui.showTicket': 'showTicketDialog'
        },
        dialogRegionEl: '#sb_dialog',

        showTicketDialog: function () {
            var region = new ModalRegion();

            var splitStartDatetime = this.model.get('booking').start_datetime.split(' ');

            var view = new TicketsItemDialogView({
                ticketCode: this.model.get('code'),
                serviceName: this.model.get('booking').service.name,
                startDate: splitStartDatetime[0],
                startTime: splitStartDatetime[1],
                endTime: this.model.get('booking').end_datetime.split(' ')[1],
                providerName: this.model.get('booking').provider.name,
            });

            region.show(view);
        },

    });

});
